/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_Tail_GeneralInputs */

const en_funnel_ob_recap_tail_general = /** @type {(inputs: Funnel_Ob_Recap_Tail_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A natural, human voice`)
};

const es_funnel_ob_recap_tail_general = /** @type {(inputs: Funnel_Ob_Recap_Tail_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una voz natural y humana`)
};

/**
* | output |
* | --- |
* | "A natural, human voice" |
*
* @param {Funnel_Ob_Recap_Tail_GeneralInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_tail_general = /** @type {((inputs?: Funnel_Ob_Recap_Tail_GeneralInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_Tail_GeneralInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_tail_general(inputs)
	return en_funnel_ob_recap_tail_general(inputs)
});